var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11, 9) scale(0.045)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.643 221.204c-7.994-10.176-19.581-16.573-32.627-18.013-13.144-1.456-26.53 2.494-36.726 10.824l-75.109 61.365c-4.855-13.939-15.896-24.999-29.825-29.876 23.78-20.239 38.893-50.371 38.893-83.97 0-60.792-49.458-110.25-110.25-110.25s-110.25 49.458-110.25 110.25c0 25.098 8.436 48.26 22.614 66.812-2.747-.141-5.512-.219-8.296-.219-33.349 0-59.21 10.373-68.469 14.657h-76.598c-8.284 0-15 6.716-15 15v187.842c0 8.284 6.716 15 15 15h80.059c8.284 0 15-6.716 15-15v-24.341h191.272c19.935 0 39.409-6.954 54.833-19.581l138.018-112.98c20.321-16.604 23.668-46.893 7.461-67.52zm-245.643-139.92c44.25 0 80.25 36 80.25 80.25s-36 80.25-80.25 80.25-80.25-36-80.25-80.25 36-80.25 80.25-80.25zm-175.941 349.342h-50.059v-157.842h50.059zm395.132-165.126-138.029 112.99c-10.079 8.251-22.804 12.795-35.83 12.795h-191.273v-123.741c9.822-3.817 27.982-9.417 50.008-9.417 13.429 0 26.271 2.02 38.171 6.004 17.154 5.742 35.405 8.653 54.245 8.653h58.886c10.204 0 18.506 8.302 18.506 18.506 0 10.205-8.302 18.507-18.506 18.507h-109.189c-8.284 0-15 6.716-15 15s6.716 15 15 15h109.188c16.401 0 30.916-8.19 39.7-20.687.022-.018.045-.032.067-.049l100.136-81.813c3.998-3.265 9.263-4.808 14.454-4.238 4.973.549 9.351 2.938 12.328 6.728 6.181 7.865 4.901 19.419-2.862 25.762z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.682 193.217c2.929 2.93 6.768 4.394 10.606 4.394s7.678-1.465 10.606-4.394l42.154-42.154c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-31.548 31.548-10.126-10.125c-5.857-5.859-15.355-5.857-21.213 0-5.858 5.858-5.858 15.355 0 21.213z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.a01e60b9fa075effdc957076c1c36ac7.svg";
export { ForwardRef as ReactComponent };